/* Drippy PDP v2 · Set page (2026-10-15 rebuild).
 *
 * A set page is the normal PDP with two size rows (pdp-v2-set-picker), the set
 * price in the title row (drippy-set-price) and a button (pdp-v2-set-buy) in
 * place of the theme's picker and product form.
 *
 *  - Price: set price = chain + bracelet - the set code's EUR saving, converted
 *    with Shopify.currency.rate outside the euro (what checkout does). Formerly:
 *    rounded to whole currency units, half up. Same maths as the checkout
 *    discount (apps/drippy-sets set-discount) and drippy-set-math.liquid.
 *  - Size guide: each row opens that piece's own guide in an overlay
 *    (?view=setguide). The size picked there is ticked here.
 *  - Add: ONE press posts BOTH real variants to /cart/add.js as two lines that
 *    share a _bundle_id. Fulfilment scans a barcode per piece, so a set is never
 *    one SKU. The discount function only discounts lines that share an id AND
 *    are the two pieces of the same set, so the saving cannot leak.
 *
 * The theme's sticky bar clones the buy column into .product__popup, so every
 * handler is delegated on document and state is read from the main picker only.
 */
(function () {
  'use strict';
  /* The buy block can be rendered twice (main + sticky bar), each with this
     script tag: run once, or every click would add the set twice. */
  if (window.__drippySetPage) return;
  window.__drippySetPage = true;

  function mainPicker() {
    var all = document.querySelectorAll('[data-set-picker]');
    for (var i = 0; i < all.length; i++) if (!all[i].closest('.product__popup')) return all[i];
    return all[0] || null;
  }
  function steps(picker) { return picker ? [].slice.call(picker.querySelectorAll('[data-set-step]')) : []; }
  function checkedIn(fs) { return fs.querySelector('input[type="radio"]:checked:not(:disabled)'); }

  /* ---- money: format cents exactly like the page's own Liquid did ---- */
  var FMT = null;
  function fmtFrom(sample) {
    // sample is 123456 cents as rendered by Liquid, e.g. "€1.234,56", "1 234,56 kr", "$1,234.56 USD"
    var m = String(sample || '').match(/1(\D?)234(\D)56/);
    if (!m) return null;
    var i = sample.indexOf(m[0]);
    return { pre: sample.slice(0, i), post: sample.slice(i + m[0].length), th: m[1], dec: m[2] };
  }
  function money(cents) {
    if (!FMT) {
      var s = document.querySelector('[data-money-sample]');
      FMT = fmtFrom(s && s.getAttribute('data-money-sample')) || { pre: '€', post: '', th: '.', dec: ',' };
    }
    var neg = cents < 0; cents = Math.abs(Math.round(cents));
    var whole = Math.floor(cents / 100), frac = cents % 100;
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, FMT.th);
    var out = w + (frac ? FMT.dec + (frac < 10 ? '0' : '') + frac : '');
    return (neg ? '-' : '') + FMT.pre + out + FMT.post;
  }
  /* The set price comes from the set's discount code: a fixed EUR amount off the
     bracelet (scripts/sets/codes.py). Outside the euro Shopify converts that amount
     at Shopify.currency.rate, rounded to cents; this does the same, so the page and
     checkout always agree. */
  function fxSaving(eurCents) {
    var r = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    return Math.round(eurCents * r);
  }
  function setMath(a, b, savingEurCents) {
    var sum = a + b, tot = sum - fxSaving(savingEurCents);
    /* Johannes 2026-10-15: outside the euro the converted saving leaves cents (214.08).
       Show the whole price rounded UP, so checkout is never above what the page says. */
    var r = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    if (r !== 1) tot = Math.ceil(tot / 100) * 100;
    return { sum: sum, sav: sum - tot, tot: tot };
  }

  /* ---- paint: group names, prices, button ---- */
  function shortSize(input) { return input && input.dataset.setNum ? input.dataset.setNum + '"' : (input ? input.value : ''); }
  function paintStep(fs) {
    var input = checkedIn(fs);
    var name = fs.querySelector('.product-form__group-name');
    if (!name) return;
    if (!fs.dataset.setLabel) {
      var raw = name.textContent.replace(/\s+/g, ' ').trim();
      fs.dataset.setLabel = raw.indexOf(':') === -1 ? raw : raw.slice(0, raw.indexOf(':'));
    }
    var label = fs.dataset.setLabel, value = input ? (input.nextElementSibling && input.nextElementSibling.querySelector('.v2-size__inch') ? input.nextElementSibling.querySelector('.v2-size__inch').textContent : shortSize(input)) : '';
    /* Stock, exactly like the normal picker (pdp-v2.js, 2026-10-10): green
       "In stock", orange "Only n left" under 30, red "Sold out", and the dot on
       the picked size (label[data-d-stock], styled by pdp-v2.css). */
    var picker = fs.closest('[data-set-picker]') || {}, D = picker.dataset || {};
    var q = input ? parseInt(input.dataset.setQty || '999', 10) : null;
    var cls = q === null ? '' : q <= 0 ? 'out' : q < 30 ? 'low' : 'in';
    var stock = q === null ? '' : q <= 0 ? D.stockOut : q < 30 ? (q === 1 ? D.stockOne : String(D.stockOther || '').replace('[n]', q)) : D.stockIn;
    [].slice.call(fs.querySelectorAll('label[data-d-stock]')).forEach(function (x) { delete x.dataset.dStock; });
    if (input && cls) { var lb = fs.querySelector('label[for="' + input.id + '"]'); if (lb) lb.dataset.dStock = cls; }
    var key = label + '|' + value + '|' + stock;
    if (name.dataset.v2Name === key) return;
    name.textContent = '';
    var l = document.createElement('span'); l.className = 'v2-optionlabel'; l.textContent = label + ':'; name.appendChild(l);
    if (value) { var v = document.createElement('span'); v.className = 'v2-optionvalue'; v.textContent = value; name.appendChild(v); }
    if (stock) { var st = document.createElement('span'); st.className = 'd-stock d-stock--' + cls; st.textContent = stock; name.appendChild(st); }
    name.dataset.v2Name = key;
  }
  function state() {
    var p = mainPicker(), s = steps(p), out = { picker: p, ok: s.length === 2, items: [], price: {} };
    s.forEach(function (fs) {
      var i = checkedIn(fs);
      var any = fs.querySelector('input[type="radio"]:not(:disabled)');
      if (!i) out.ok = false;
      if (!any) out.soldOut = true;
      if (i) { out.items.push(parseInt(i.dataset.setVariant, 10)); out.price[fs.dataset.setStep] = parseInt(i.dataset.setPrice, 10); }
      else { var f0 = fs.querySelector('input[type="radio"]:not(:disabled)') || fs.querySelector('input[type="radio"]'); if (f0) out.price[fs.dataset.setStep] = parseInt(f0.dataset.setPrice, 10); }
    });
    return out;
  }
  function paintAll() {
    var pickers = document.querySelectorAll('[data-set-picker]');
    for (var i = 0; i < pickers.length; i++) steps(pickers[i]).forEach(paintStep);
    var st = state();
    if (st.picker && st.price.chain != null && st.price.bracelet != null) {
      var m = setMath(st.price.chain, st.price.bracelet, parseInt(st.picker.dataset.setSaving || '0', 10));
      each('[data-set-total]', function (el) { el.textContent = money(m.tot); });
      each('[data-set-sum]', function (el) { el.textContent = money(m.sum); });
      each('[data-set-save]', function (el) {
        var line = el.closest('[data-tpl]'); var tpl = line && line.getAttribute('data-tpl');
        if (tpl) el.textContent = tpl.replace('%A', money(m.sav));
      });
      each('[data-set-piece-price="chain"]', function (el) { el.textContent = money(st.price.chain); });
      each('[data-set-piece-price="bracelet"]', function (el) { el.textContent = money(st.price.bracelet); });
      each('.d-fx', function (el) { el.classList.remove('d-fx'); });
    }
    /* Like every PDP: the button reads Add to cart and stays live; pressed
       before both sizes are picked it shakes the missing row (add()). Only a
       piece with no size in stock turns it into Sold out. */
    each('[data-set-add]', function (b) {
      b.disabled = !!st.soldOut;
      var lab = b.querySelector('[data-set-add-label]');
      if (lab) lab.textContent = st.soldOut ? b.dataset.labelSold : b.dataset.labelAdd;
    });
  }
  function each(sel, fn) { var n = document.querySelectorAll(sel); for (var i = 0; i < n.length; i++) fn(n[i]); }

  /* ---- sticky bar copy: own radio names, mirrored both ways ---- */
  function baseName(n) { return String(n || '').replace(/-bar$/, ''); }
  function mirror(input) {
    var base = baseName(input.name);
    each('[data-set-picker] input[type="radio"]', function (r) {
      if (r !== input && baseName(r.name) === base && r.value === input.value && !r.checked) r.checked = true;
    });
  }
  function scopeClones() {
    each('.product__popup [data-set-picker] input[type="radio"]', function (r) {
      if (/-bar$/.test(r.name)) return;
      var box = r.closest('[data-set-picker]');
      var lab = box.querySelector('label[for="' + r.id + '"]');
      r.name = r.name + '-bar'; r.id = r.id + '-bar';
      if (lab) lab.setAttribute('for', r.id);
    });
    var main = mainPicker();
    if (main) [].slice.call(main.querySelectorAll('input[type="radio"]:checked')).forEach(mirror);
  }
  function restoreMain() { /* 2026-10-15: no preselected size, like every PDP */ }

  /* ---- size guide overlay: the piece's own guide ---- */
  var overlay = null;
  function closeGuide() {
    if (!overlay) return;
    var o = overlay; overlay = null;
    o.classList.remove('is-ready');
    document.documentElement.classList.remove('d-sgframe-open');
    setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 200);
    if (o._back && o._back.focus) o._back.focus();
  }
  function openGuide(btn) {
    var fs = btn.closest('[data-set-step]');
    var piece = fs && fs.dataset.setStep;
    var main = steps(mainPicker()).filter(function (f) { return f.dataset.setStep === piece; })[0];
    if (!main) return;
    closeGuide();
    var cur = checkedIn(main);
    overlay = document.createElement('div');
    overlay.className = 'd-sgframe';
    overlay.setAttribute('data-piece', piece);
    overlay._back = btn;
    overlay.innerHTML = '<div class="d-sgframe__wait" aria-hidden="true"><span></span></div>';
    document.body.appendChild(overlay);
    document.documentElement.classList.add('d-sgframe-open');
    var mine = overlay;
    /* Shopify serves every storefront page with frame-ancestors 'none', so the
       guide view cannot be framed by URL. Fetch it (same origin, same market,
       same language, same preview theme) and load it as an inline document. */
    fetch(main.dataset.setGuide, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (overlay !== mine) return;
        var opts = '<script>window.__SG=' + JSON.stringify({ size: cur ? cur.value : '', open: 'finder' }).replace(/</g, '\\u003c') + ';<\/script>';
        html = html.replace(/<head([^>]*)>/i, '<head$1><base href="' + location.origin + '/">' + opts);
        var f = document.createElement('iframe');
        f.title = btn.textContent.replace(/\s+/g, ' ').trim();
        f.setAttribute('srcdoc', html);
        mine.appendChild(f);
        mine._frame = f;
        mine._t = setTimeout(function () { if (overlay === mine && !mine.classList.contains('is-ready')) closeGuide(); }, 8000);
      })
      .catch(function () { if (overlay === mine) closeGuide(); });
  }
  window.addEventListener('message', function (e) {
    if (!overlay || !overlay._frame || e.source !== overlay._frame.contentWindow || !e.data || !e.data.drippySetGuide) return;
    var d = e.data, piece = overlay.getAttribute('data-piece');
    if (d.type === 'ready') { overlay.classList.add('is-ready'); var fr = overlay.querySelector('iframe'); if (fr) fr.focus(); }
    else if (d.type === 'close' || d.type === 'none') closeGuide();
    else if (d.type === 'pick') {
      var fs = steps(mainPicker()).filter(function (f) { return f.dataset.setStep === piece; })[0];
      var r = fs && [].slice.call(fs.querySelectorAll('input[type="radio"]')).filter(function (x) { return x.value === d.value; })[0];
      if (r && !r.disabled) { r.checked = true; mirror(r); paintAll(); }
    }
  });

  /* ---- add to cart ---- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function setBusy(busy) {
    each('[data-set-add]', function (b) {
      b.disabled = busy || !state().ok;
      var sp = b.querySelector('.loading-overlay__spinner'); if (sp) sp.classList.toggle('hidden', !busy);
    });
  }
  function showError(msg) {
    each('[data-set-error]', function (w) {
      var t = w.querySelector('.product-form__error-message'); if (t) t.textContent = msg || '';
      w.hidden = !msg;
    });
  }
  function hint() {
    var miss = steps(mainPicker()).filter(function (f) { return !checkedIn(f); })[0];
    if (!miss) return;
    miss.classList.remove('d-size-shake'); void miss.offsetWidth; miss.classList.add('d-size-shake');
    miss.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function applyCode(code, sections, url) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!code) return Promise.resolve(null);
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var list = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      if (list.indexOf(code) === -1) list.push(code);
      var b = { discount: list.join(',') };
      if (sections) { b.sections = sections; b.sections_url = url; }
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }).then(function (r) { return r.json(); });
    }).catch(function () { return null; });
  }
  function add() {
    var st = state();
    if (!st.ok) { hint(); return; }
    showError('');
    setBusy(true);
    var id = 'set-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var props = { _bundle_id: id, _bundle_name: st.picker.dataset.setName || 'Set', _bundle_handle: st.picker.dataset.setHandle || '' };
    var items = st.items.map(function (v) { return { id: v, quantity: 1, properties: props }; });
    var d = drawer(), body = { items: items };
    if (d && typeof d.getSectionsToRender === 'function') {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) return res;
        /* The set price is the set's discount code: apply it to the cart, keeping any
           code already there, and take the drawer sections from that answer. */
        return applyCode(st.picker.dataset.setCode, body.sections, body.sections_url).then(function (r2) { return r2 || res; });
      })
      .then(function (res) {
        if (res.status) { setBusy(false); showError(res.description || res.message || ''); return; }
        var dd = drawer();
        if (dd && typeof dd.renderContents === 'function' && res.sections) {
          dd.renderContents(res);
          /* cart v2's "Added: <name>" shows one line's name; a set is both. */
          var nm = document.querySelector('.v2-titlerow__name');
          each('[data-cv2-added-name]', function (el) { if (nm) el.textContent = nm.textContent.trim(); });
          if (typeof dd.open === 'function') dd.open();
          setBusy(false); paintAll();
          return;
        }
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      })
      .catch(function (err) {
        if (window.console) console.error('[set]', err);
        setBusy(false);
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.closest('[data-set-picker]')) return;
    mirror(t); paintAll();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-set-add]')) { e.preventDefault(); e.stopImmediatePropagation(); add(); return; }
    var sg = t.closest('[data-set-sg]');
    if (sg) { e.preventDefault(); e.stopPropagation(); openGuide(sg); return; }
    if (overlay && t === overlay) closeGuide();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay) closeGuide(); });

  /* Reviews sheet (pdp-v2.js): on a PDP it ends with the Loox review list. A set
     has none of its own, so the sheet gets the pieces' review cards instead
     (the same cards as the reviews section further down the page). */
  function fillSheet() {
    var box = document.querySelector('.drs [data-drs-loox]');
    var list = document.querySelector('#set-reviews .d-srev__list');
    if (!box || !list || box.querySelector('.d-srev-sheet')) return;
    var w = document.createElement('div'); w.className = 'd-srev-sheet';
    w.innerHTML = list.innerHTML;
    box.appendChild(w);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.d-rating-under, .product__info-container .loox-rating')) fillSheet();
  }, true);

  function settle() { restoreMain(); scopeClones(); paintAll(); }
  function boot() {
    settle();
    setTimeout(settle, 50);
    setTimeout(settle, 800);
    var popup = document.querySelector('.product__popup');
    if (popup && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(settle, 30); }).observe(popup, { childList: true, subtree: true });
    }
    /* Back/forward cache: a restored page keeps the last ticks; repaint. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) settle(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
